import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="bg-white" style={{ boxShadow: 'var(--shadow-sm)', position: 'sticky', top: 0, zIndex: 50 }}>
      <nav className="container">
        <div className="flex" style={{ justifyContent: 'space-between', alignItems: 'center', padding: '20px 0' }}>
          <div style={{ flexShrink: 0 }}>
            <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'var(--gray-900)', margin: '0 0 4px 0', letterSpacing: '-0.5px', lineHeight: '1.1' }}>Natalie Vinueza</h1>
            <p style={{ fontSize: '14px', color: 'var(--gray-500)', margin: '0 0 6px 0', fontWeight: '500', lineHeight: '1.2' }}>Persona Coach</p>
            <a href="mailto:info@personacoach.net" style={{ 
              fontSize: '13px', 
              color: 'var(--primary-green)', 
              margin: 0, 
              fontWeight: '500', 
              textDecoration: 'none',
              lineHeight: '1.2',
              transition: 'color 0.2s ease',
              display: 'block'
            }}
            onMouseOver={(e) => (e.target as HTMLElement).style.color = 'var(--primary-green-hover)'}
            onMouseOut={(e) => (e.target as HTMLElement).style.color = 'var(--primary-green)'}
            >
              info@personacoach.net
            </a>
          </div>
          <div className="flex items-center gap-8" style={{ display: 'flex', flexWrap: 'wrap' }}>
            <a href="#services" className="nav-link">
              Offerings
            </a>
            <a href="#about" className="nav-link">
              About
            </a>
            <a href="#contact" className="btn btn-primary">
              Book Consultation
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;